export enum MilestoneConfirmModalType {
  REQUEST_CANCEL,
  CANCEL,
  REQUEST_RELEASE,
  RELEASE,
}

export enum MilestoneConfirmModalResponse {
  SUCCESS,
  FAILURE,
}
